/** Fires `multiple_bets_toggle` when the user switches between single and multiple-bets mode. */
export const trackMultipleBetsToggle = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		game_name: content.lottery_name,
		mode: content.mode,
		selected_count_main: content.selected_count_main,
		selected_count_special: content.selected_count_special,
		timestamp: new Date().toISOString(),
		numbers: content.numbers,
	}
	LuckyWiseAnalytics.click('multiple_bets_toggle', params)
}

/** Fires `multiple_bets_analysis_started` when the user triggers a multiple-bets result analysis. */
export const trackMultipleBetsStarted = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		combination_count: content.combination_count,
		timestamp: new Date().toISOString(),
		numbers: content.numbers,
	}
	LuckyWiseAnalytics.click('multiple_bets_analysis_started', params)
}
